import { Spin } from "antd";
import { Navigate } from "react-router-dom";

import { useAuth, AuthenticationStatus } from "./useAuth";

/**
 * Wrap the routes with a private route component to check if the user is authenticated
 * and to redirect to the login page if not.
 */
const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const auth = useAuth();

  switch (auth.authenticationStatus) {
    case AuthenticationStatus.LOADING:
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Spin />
        </div>
      );
    case AuthenticationStatus.LOGGED_OUT:
      return <Navigate to="/login" />;
    case AuthenticationStatus.LOGGED_IN:
      return children;
  }
};

export default PrivateRoute;
